import React from 'react';

export type LegendEolStageAbbrev = 'EOL' | 'EOSa' | 'EOSu' | 'Decom';

type LegendEolStageBadgeProps = {
  abbrev: LegendEolStageAbbrev;
  className?: string;
  badgeClassName?: string;
};

/** EOL stage abbrev badge for roadmap legend (Figma: 24px slot, 12px bold gray-400). */
export const LegendEolStageBadge: React.FC<LegendEolStageBadgeProps> = ({
  abbrev,
  className,
  badgeClassName
}) => (
  <div className={className}>
    <span className={badgeClassName}>{abbrev}</span>
  </div>
);
